  const API_BASE = "https://recipe-api.bellelife.jp";
  const API_GENERATE = API_BASE + "/api/generate_one";
  const API_DEVICES  = API_BASE + "/api/devices";
  const API_DEFAULTS = API_BASE + "/api/defaults";
  const API_FEEDBACK = API_BASE + "/api/feedback";      // 新增
  const API_LOG_ACTION = API_BASE + "/api/log_action";  // 新增
  const LOGO_URL = window.RECIPE_LOGO_URL || "";
  console.log("RECIPE_LOGO_URL =", LOGO_URL);

  const FIXED_STYLE = "家常";
  const FIXED_LANGUAGE = "日文";

  const IS_LOGGED_IN = !!window.RECIPE_CUSTOMER_LOGGED_IN;
  const LOGIN_URL = window.RECIPE_LOGIN_URL || "/account/login";

  const feedbackFloatBtn = document.getElementById("feedbackFloatBtn");
  const feedbackModal = document.getElementById("feedbackModal");
  const feedbackStars = document.querySelectorAll("#feedbackStars span");
  const feedbackText = document.getElementById("feedbackText");
  const feedbackCancelBtn = document.getElementById("feedbackCancelBtn");
  const feedbackConfirmBtn = document.getElementById("feedbackConfirmBtn");

  let defaultInstructions = "";
  let defaultImgStyle = "";
  let feedbackRating = 0;
  let currentRecipeId = "";  // 当前生成的菜谱 request_id

  const inputTypeRadios = document.querySelectorAll('#bl-recipe-app input[name="inputType"]');
  function getInputType() {
    const checked = document.querySelector('#bl-recipe-app input[name="inputType"]:checked');
    return checked ? checked.value : "ingredients";
  }
  const ingredientsInput = document.getElementById("ingredients");

  const aiOutBox = document.getElementById("aiOutput");
  const dishImage = document.getElementById("dishImage");
  const imagePlaceholder = document.getElementById("imagePlaceholder");

  const modelSelect = document.getElementById("deviceModel");
  const modeSelect  = document.getElementById("deviceMode");

  const btnRunAI = document.getElementById("btnRunAI");
  const btnDownloadImage = document.getElementById("btnDownloadImage");

  let fullImageUrl = "";
  let fullImageRevoke = null;

  let deviceModels = [];
  let modesByModel = {};

  function hasFreeUsed() {
    return localStorage.getItem("recipe_free_used") === "1";
  }

  function setFreeUsed() {
    localStorage.setItem("recipe_free_used", "1");
  }

  dishImage.style.cursor = "zoom-in";
  dishImage.title = "クリックして拡大表示";
  dishImage.addEventListener("click", () => {
    if (fullImageUrl) {
      window.open(fullImageUrl, "_blank");
    }
  });

  inputTypeRadios.forEach(radio => {
    radio.addEventListener("change", () => {
      if (getInputType() === "ingredients") {
        ingredientsInput.placeholder = "例：卵、トマト";
      } else {
        ingredientsInput.placeholder = "例：親子丼";
      }
    });
  });

  function setFullImageFromDataUrl(dataUrl) {
    if (fullImageRevoke) {
      fullImageRevoke();
      fullImageRevoke = null;
    }
    fullImageUrl = "";

    if (!dataUrl || !dataUrl.startsWith("data:image/")) return;

    const [meta, b64] = dataUrl.split(",", 2);
    const mime = (meta.match(/data:(.*?);base64/) || [])[1] || "image/png";

    const bytes = atob(b64);
    const arr = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
      arr[i] = bytes.charCodeAt(i);
    }

    const blob = new Blob([arr], { type: mime });
    const url = URL.createObjectURL(blob);
    fullImageUrl = url;
    fullImageRevoke = () => URL.revokeObjectURL(url);
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  async function applyBrandOverlay(dataUrl) {
    const baseImg = await loadImage(dataUrl);
    const logoImg = await loadImage(LOGO_URL);

    const canvas = document.createElement("canvas");
    canvas.width = baseImg.naturalWidth;
    canvas.height = baseImg.naturalHeight;

    const ctx = canvas.getContext("2d");

    ctx.drawImage(baseImg, 0, 0, canvas.width, canvas.height);

    // logo：右上角
    const logoWidth = Math.round(canvas.width * 0.48);

    const logoHeight = Math.round(
      logoImg.naturalHeight * logoWidth / logoImg.naturalWidth
    );

    // 右上角贴边
    const logoX = canvas.width - logoWidth;
    const logoY = 0;

    // 其他元素继续使用 padding
    const padding = Math.round(canvas.width * 0.045);


    ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);

    // 设备名：右下角，明朝体，白边黑字，类似落款
    const modelObj = deviceModels.find(x => x.id === modelSelect.value);
    const modelText = modelObj ? modelObj.name : modelSelect.value;

    const fontSize = Math.round(canvas.width * 0.034);

    ctx.font = `bold ${fontSize}px "Yu Mincho", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "MS Mincho", serif`;
    ctx.textAlign = "right";
    ctx.textBaseline = "bottom";

    const textX = canvas.width - padding;
    const textY = canvas.height - padding;

    ctx.lineWidth = Math.round(fontSize * 0.18);
    ctx.strokeStyle = "rgba(255, 255, 255, 0.95)";
    ctx.fillStyle = "#111";

    ctx.strokeText(modelText, textX, textY);
    ctx.fillText(modelText, textX, textY);

    return canvas.toDataURL("image/png");
  }

  function renderModeOptions() {
    modeSelect.innerHTML = "";
    const modelId = modelSelect.value;
    const modes = modesByModel[modelId] || [];

    for (const m of modes) {
      const opt = document.createElement("option");
      opt.value = m.id;
      opt.textContent = m.name;
      modeSelect.appendChild(opt);
    }

    if (modes.length > 0) {
      modeSelect.value = modes[0].id;
    }
  }

  function onModelChange() {
    renderModeOptions();
  }

  async function loadDefaults() {
    const r = await fetch(API_DEFAULTS);
    const data = await r.json();

    if (data.ok) {
      defaultInstructions = (data.instructions || "").trim();
      defaultImgStyle = (data.img_style || "").trim();
    }
  }

  async function loadDevices() {
    modelSelect.innerHTML = "";
    modeSelect.innerHTML = "";

    const r = await fetch(API_DEVICES);
    const data = await r.json();

    if (!data.ok) {
      aiOutBox.value = "機種データの読み込みに失敗しました";
      return;
    }

    deviceModels = data.models || [];
    modesByModel = data.modes_by_model || {};

    if (deviceModels.length === 0) {
      aiOutBox.value = "機種データがありません";
      return;
    }

    for (const m of deviceModels) {
      const opt = document.createElement("option");
      opt.value = m.id;
      opt.textContent = m.name;
      modelSelect.appendChild(opt);
    }

    modelSelect.value = deviceModels[0].id;
    onModelChange();
  }

  function buildPayload() {
    const inputType = getInputType();
    const ingredients = ingredientsInput.value.trim();

    return {
      input_type: inputType,
      ingredients,
      style: FIXED_STYLE,
      language: FIXED_LANGUAGE,
      instructions: defaultInstructions,
      device_model_id: modelSelect.value,
      device_mode_id: modeSelect.value,
      img_style: defaultImgStyle,
    };
  }

  function resetResultArea() {
    aiOutBox.value = "";
    dishImage.style.display = "none";
    dishImage.src = "";
    fullImageUrl = "";
    btnDownloadImage.style.display = "none";
    imagePlaceholder.style.display = "block";
    hideFeedbackButton();

    feedbackModal.style.display = "none";
    feedbackRating = 0;
    feedbackText.value = "";
    feedbackStars.forEach(s => s.classList.remove("active"));

    if (fullImageRevoke) {
      fullImageRevoke();
      fullImageRevoke = null;
    }
  }

  async function init() {
    btnRunAI.disabled = true;

    try {
      await Promise.all([loadDevices(), loadDefaults()]);
    } catch (err) {
      aiOutBox.value = "初期化に失敗しました: " + err;
    } finally {
      btnRunAI.disabled = false;
    }
  }

  modelSelect.addEventListener("change", onModelChange);
  document.getElementById("f").addEventListener("submit", (e) => e.preventDefault());

  // btnRunAI.addEventListener("click", async () => {

  //   if (!IS_LOGGED_IN && hasFreeUsed()) {
  //   // if (false && !IS_LOGGED_IN && hasFreeUsed()) {  //测试用 避免触发注册

  //     const goLogin = confirm(
  //       "無料利用は1回までです。\nログイン後に引き続きご利用いただけます。"
  //     );

  //     if (goLogin) {
  //       window.location.href = LOGIN_URL;
  //     }

  //     return;
  //   }

  //   const ingredients = ingredientsInput.value.trim();

  //   if (!ingredients) {
  //     alert(getInputType() === "dish" ? "料理名を入力してください" : "食材を入力してください");
  //     ingredientsInput.focus();
  //     return;
  //   }

  //   const payload = buildPayload();

  //   resetResultArea();
  //   aiOutBox.value = "生成中…";

  //   const oldText = btnRunAI.textContent;
  //   btnRunAI.disabled = true;
  //   btnRunAI.textContent = "生成中...";

  //   try {
  //     const r = await fetch(API_GENERATE, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const raw = await r.text();

  //     let data;

  //     try {
  //       data = JSON.parse(raw);
  //     } catch (e) {
  //       aiOutBox.value = `JSONではないレスポンスが返されました（HTTP ${r.status}）\n\n` + raw;
  //       return;
  //     }

  //     if (!data.ok) {
  //       aiOutBox.value = "サーバーエラー\n\n" + JSON.stringify(data, null, 2);
  //       currentRecipeId = "";
  //       return;
  //     }

  //     currentRecipeId = data.request_id || "";
  //     aiOutBox.value = data.ai_output || "";

  //     if (!IS_LOGGED_IN) {
  //       setFreeUsed();
  //     }

  //     if (data.image_b64) {
  //       const rawImageUrl = "data:image/png;base64," + data.image_b64;
  //       let brandedImageUrl = rawImageUrl;

  //       try {
  //         brandedImageUrl = await applyBrandOverlay(rawImageUrl);
  //       } catch (e) {
  //         console.error("brand overlay failed", e);
  //       }

  //       dishImage.src = brandedImageUrl;
  //       dishImage.style.display = "block";
  //       imagePlaceholder.style.display = "none";
  //       setFullImageFromDataUrl(brandedImageUrl);
  //     }
  //     btnDownloadImage.style.display = "block";
  //     showFeedbackButton();
      
  //     document.querySelector(".row2").scrollIntoView({
  //       behavior: "smooth",
  //       block: "start"
  //     });

  //   } catch (err) {
  //     aiOutBox.value = "リクエストに失敗しました: " + err;
  //   } finally {
  //     btnRunAI.disabled = false;
  //     btnRunAI.textContent = oldText;
  //   }
  // });


  // btnRunAI.addEventListener("click", async () => {
  //   // ... 前置校验逻辑 ...

  //   const payload = buildPayload();
  //   resetResultArea();
    
  //   // 状态切换统一化
  //   const oldText = btnRunAI.textContent;
  //   btnRunAI.disabled = true;
  //   btnRunAI.textContent = "生成中...";

  //   try {
  //       const r = await fetch(API_GENERATE, {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify(payload),
  //       });

  //       // 核心加固：明确检查 status
  //       if (!r.ok) {
  //           throw new Error(`服务器响应错误: ${r.status}`);
  //       }

  //       const data = await r.json();

  //       if (!data.ok) {
  //           throw new Error(data.message || "后端逻辑执行失败");
  //       }

  //       // --- 以下逻辑只在成功时执行 ---
  //       currentRecipeId = data.request_id || "";
  //       aiOutBox.value = data.ai_output || "";
        
  //       if (!IS_LOGGED_IN) setFreeUsed();

  //       if (data.image_b64) {
  //           // 这里加入更严格的错误边界
  //           const rawImageUrl = "data:image/png;base64," + data.image_b64;
  //           const brandedImageUrl = await applyBrandOverlay(rawImageUrl).catch(e => {
  //               console.error("brand overlay failed", e);
  //               return rawImageUrl; // 即使水印失败，也不影响图片显示
  //           });

  //           dishImage.src = brandedImageUrl;
  //           dishImage.style.display = "block";
  //           imagePlaceholder.style.display = "none";
  //           setFullImageFromDataUrl(brandedImageUrl);
  //       }
  //       btnDownloadImage.style.display = "block";
  //       showFeedbackButton();
  //       document.querySelector("#bl-recipe-app .row2")?.scrollIntoView({ behavior: "smooth" });

  //   } catch (err) {
  //       // 将错误明确展示给用户，防止“无反应”的锁死感
  //       aiOutBox.value = "生成に失敗しました: " + err.message;
  //       console.error("生成失败:", err);
  //   } finally {
  //       // 这一块绝对保证按钮恢复
  //       btnRunAI.disabled = false;
  //       btnRunAI.textContent = oldText;
  //   }
  // });

  btnRunAI.addEventListener("click", async () => {
    // 1. 检查输入内容
    const ingredients = ingredientsInput.value.trim();

    if (!ingredients) {
      alert(
        getInputType() === "dish"
          ? "料理名を入力してください"
          : "食材を入力してください"
      );
      ingredientsInput.focus();
      return;
    }

    // 2. 未登录用户只能免费使用一次
    if (!IS_LOGGED_IN && hasFreeUsed()) {
      const goLogin = confirm(
        "無料利用は1回までです。\nログイン後に引き続きご利用いただけます。"
      );

      if (goLogin) {
        window.location.href = LOGIN_URL;
      }

      return;
    }

    // 3. 准备请求
    const payload = buildPayload();

    resetResultArea();
    currentRecipeId = "";
    aiOutBox.value = "生成中…";

    const oldText = btnRunAI.textContent;
    btnRunAI.disabled = true;
    btnRunAI.textContent = "生成中...";

    try {
      const r = await fetch(API_GENERATE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      // 先读取原始响应，避免服务器返回非 JSON 时丢失错误信息
      const raw = await r.text();
      let data = null;

      try {
        data = JSON.parse(raw);
      } catch (parseError) {
        throw new Error(
          `JSONではないレスポンスが返されました（HTTP ${r.status}）`
        );
      }

      // 检查 HTTP 状态
      if (!r.ok) {
        const errorMessage =
          data.message ||
          data.detail ||
          `サーバー応答エラー（HTTP ${r.status}）`;

        throw new Error(
          typeof errorMessage === "string"
            ? errorMessage
            : JSON.stringify(errorMessage)
        );
      }

      // 检查后端业务状态
      if (!data.ok) {
        throw new Error(
          data.message ||
          data.detail ||
          "レシピの生成に失敗しました"
        );
      }

      // 4. 生成成功
      currentRecipeId = data.request_id || "";
      aiOutBox.value = data.ai_output || "";

      // 只有真正生成成功后，才记录游客已使用免费次数
      if (!IS_LOGGED_IN) {
        setFreeUsed();
      }

      // 5. 处理菜品图片
      if (data.image_b64) {
        const rawImageUrl =
          "data:image/png;base64," + data.image_b64;

        const brandedImageUrl = await applyBrandOverlay(rawImageUrl)
          .catch((error) => {
            console.error("brand overlay failed", error);
            return rawImageUrl;
          });

        dishImage.src = brandedImageUrl;
        dishImage.style.display = "block";
        imagePlaceholder.style.display = "none";
        setFullImageFromDataUrl(brandedImageUrl);
      }

      btnDownloadImage.style.display = "block";
      showFeedbackButton();

      document
        .querySelector("#bl-recipe-app .row2")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

    } catch (error) {
      currentRecipeId = "";
      aiOutBox.value =
        "生成に失敗しました: " +
        (error.message || String(error));

      console.error("生成失败:", error);

    } finally {
      btnRunAI.disabled = false;
      btnRunAI.textContent = oldText;
    }
  });

  // btnDownloadImage.addEventListener("click", async () => {
  //   let downloadSuccess = false;
    
  //   try {
  //       // 【核心优化】：同时兼容 textarea 和普通 div 标签，防止因拿不到文本导致 trim() 报错崩溃
  //       const textContent = (aiOutBox.value || aiOutBox.textContent || aiOutBox.innerText || "").trim();
  //       const base64Src = dishImage.src;

  //       if (!textContent) {
  //           alert("保存するレシピがありません");
  //           return;
  //       }
  //       if (!base64Src || dishImage.style.display === "none") {
  //           alert("保存する画像がありません");
  //           return;
  //       }

  //       btnDownloadImage.disabled = true;
  //       btnDownloadImage.textContent = "保存中...";

  //       // 1. 创建后台隐形画布
  //       const canvas = document.createElement("canvas");
  //       const ctx = canvas.getContext("2d");
        
  //       // 2. 异步等候 Base64 图片在内存中彻底加载完毕
  //       const mainImg = new Image();
  //       await new Promise((resolve, reject) => {
  //           mainImg.onload = resolve;
  //           mainImg.onerror = reject;
  //           mainImg.src = base64Src;
  //       });

  //       // 3. 规划画布尺寸（固定宽度 750px，高度动态计算）
  //       const canvasWidth = 750;
  //       const padding = 40;
  //       const contentWidth = canvasWidth - (padding * 2);

  //       // 4. 计算文本换行，防止文字超出画布边界
  //       ctx.font = "16px sans-serif";
  //       const lines = [];
  //       const rawLines = textContent.split("\n");
        
  //       rawLines.forEach(rawLine => {
  //           if (rawLine.length === 0) {
  //               lines.push("");
  //               return;
  //           }
  //           let currentLine = "";
  //           for (let i = 0; i < rawLine.length; i++) {
  //               let char = rawLine[i];
  //               let testLine = currentLine + char;
  //               let metrics = ctx.measureText(testLine);
  //               if (metrics.width > contentWidth) {
  //                   lines.push(currentLine);
  //                   currentLine = char;
  //               } else {
  //                   currentLine = testLine;
  //               }
  //           }
  //           if (currentLine) lines.push(currentLine);
  //       });

  //       const lineHeight = 28;
  //       const textTotalHeight = lines.length * lineHeight;
        
  //       // 根据原图比例，计算图片在 750px 画布宽度下的等比例高度
  //       const destImgHeight = (mainImg.naturalHeight * contentWidth) / mainImg.naturalWidth;

  //       // 总高度 = 上下边距 + 文本总高度 + 文本与图片的间距(30px) + 图片高度
  //       canvas.width = canvasWidth;
  //       canvas.height = padding + textTotalHeight + 30 + destImgHeight + padding;

  //       // 5. 绘制纯白背景
  //       ctx.fillStyle = "#ffffff";
  //       ctx.fillRect(0, 0, canvas.width, canvas.height);

  //       // 6. 逐行绘制菜谱文本
  //       ctx.fillStyle = "#222222";
  //       ctx.font = "16px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
  //       ctx.textBaseline = "top";

  //       lines.forEach((line, index) => {
  //           ctx.fillText(line, padding, padding + (index * lineHeight));
  //       });

  //       // 7. 绘制下方菜品图片（附带 12px 圆角效果，对齐 UI 风格）
  //       const imgY = padding + textTotalHeight + 30;
        
  //       ctx.save();
  //       const radius = 12;
  //       ctx.beginPath();
  //       ctx.moveTo(padding + radius, imgY);
  //       ctx.lineTo(padding + contentWidth - radius, imgY);
  //       ctx.quadraticCurveTo(padding + contentWidth, imgY, padding + contentWidth, imgY + radius);
  //       ctx.lineTo(padding + contentWidth, imgY + destImgHeight - radius);
  //       ctx.quadraticCurveTo(padding + contentWidth, imgY + destImgHeight, padding + contentWidth - radius, imgY + destImgHeight);
  //       ctx.lineTo(padding + radius, imgY + destImgHeight);
  //       ctx.quadraticCurveTo(padding, imgY + destImgHeight, padding, imgY + destImgHeight - radius);
  //       ctx.lineTo(padding, imgY + radius);
  //       ctx.quadraticCurveTo(padding, imgY, padding + radius, imgY);
  //       ctx.closePath();
  //       ctx.clip();
        
  //       ctx.drawImage(mainImg, padding, imgY, contentWidth, destImgHeight);
  //       ctx.restore();

  //       // 8. 触发浏览器原生下载
  //       const link = document.createElement("a");
  //       link.download = "recipe_" + (currentRecipeId || "export") + ".jpg";
  //       link.href = canvas.toDataURL("image/jpeg", 0.95);
  //       link.click();

  //       downloadSuccess = true;

  //   } catch (err) {
  //       console.error("生成长图失败:", err);
  //       alert("画像保存に失敗しました");
  //   } finally {
  //       btnDownloadImage.disabled = false;
  //       btnDownloadImage.textContent = "レシピを保存する";
  //   }

  //   // 9. 将下载结果异步上报给后端打点系统
  //   if (currentRecipeId) {
  //       try {
  //           await fetch(API_LOG_ACTION, {
  //               method: "POST",
  //               headers: { "Content-Type": "application/json" },
  //               body: JSON.stringify({
  //                   request_id: currentRecipeId,
  //                   action: "download_recipe",
  //                   success: downloadSuccess
  //               }),
  //           });
  //           console.log("下载日志已提交");
  //       } catch (err) {
  //           console.error("下载日志提交失败:", err);
  //       }
  //   }
  // });

  // btnDownloadImage.addEventListener("click", async () => {
  //   let downloadSuccess = false;
  //   btnDownloadImage.disabled = true;
  //   btnDownloadImage.textContent = "保存中...";

  //   try {
  //       // 【核心优化】：同时兼容 textarea 和普通 div 标签，防止因拿不到文本导致 trim() 报错崩溃
  //       const textContent = (aiOutBox.value || aiOutBox.textContent || aiOutBox.innerText || "").trim();
  //       const base64Src = dishImage.src;

  //       if (!textContent) {
  //           alert("保存するレシピがありません");
  //           return;
  //       }
  //       if (!base64Src || dishImage.style.display === "none") {
  //           alert("保存する画像がありません");
  //           return;
  //       }

  //       btnDownloadImage.disabled = true;
  //       btnDownloadImage.textContent = "保存中...";

  //       // 1. 创建后台隐形画布
  //       const canvas = document.createElement("canvas");
  //       const ctx = canvas.getContext("2d");
        
  //       // 2. 异步等候 Base64 图片在内存中彻底加载完毕
  //       const mainImg = new Image();
  //       await new Promise((resolve, reject) => {
  //           mainImg.onload = resolve;
  //           mainImg.onerror = reject;
  //           mainImg.src = base64Src;
  //       });

  //       // 3. 规划画布尺寸（固定宽度 750px，高度动态计算）
  //       const canvasWidth = 750;
  //       const padding = 40;
  //       const contentWidth = canvasWidth - (padding * 2);

  //       // 4. 计算文本换行，防止文字超出画布边界
  //       ctx.font = "16px sans-serif";
  //       const lines = [];
  //       const rawLines = textContent.split("\n");
        
  //       rawLines.forEach(rawLine => {
  //           if (rawLine.length === 0) {
  //               lines.push("");
  //               return;
  //           }
  //           let currentLine = "";
  //           for (let i = 0; i < rawLine.length; i++) {
  //               let char = rawLine[i];
  //               let testLine = currentLine + char;
  //               let metrics = ctx.measureText(testLine);
  //               if (metrics.width > contentWidth) {
  //                   lines.push(currentLine);
  //                   currentLine = char;
  //               } else {
  //                   currentLine = testLine;
  //               }
  //           }
  //           if (currentLine) lines.push(currentLine);
  //       });

  //       const lineHeight = 28;
  //       const textTotalHeight = lines.length * lineHeight;
        
  //       // 根据原图比例，计算图片在 750px 画布宽度下的等比例高度
  //       const destImgHeight = (mainImg.naturalHeight * contentWidth) / mainImg.naturalWidth;

  //       // 总高度 = 上下边距 + 文本总高度 + 文本与图片的间距(30px) + 图片高度
  //       canvas.width = canvasWidth;
  //       canvas.height = padding + textTotalHeight + 30 + destImgHeight + padding;

  //       // 5. 绘制纯白背景
  //       ctx.fillStyle = "#ffffff";
  //       ctx.fillRect(0, 0, canvas.width, canvas.height);

  //       // 6. 逐行绘制菜谱文本
  //       ctx.fillStyle = "#222222";
  //       ctx.font = "16px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
  //       ctx.textBaseline = "top";

  //       lines.forEach((line, index) => {
  //           ctx.fillText(line, padding, padding + (index * lineHeight));
  //       });

  //       // 7. 绘制下方菜品图片（附带 12px 圆角效果，对齐 UI 风格）
  //       const imgY = padding + textTotalHeight + 30;
        
  //       ctx.save();
  //       const radius = 12;
  //       ctx.beginPath();
  //       ctx.moveTo(padding + radius, imgY);
  //       ctx.lineTo(padding + contentWidth - radius, imgY);
  //       ctx.quadraticCurveTo(padding + contentWidth, imgY, padding + contentWidth, imgY + radius);
  //       ctx.lineTo(padding + contentWidth, imgY + destImgHeight - radius);
  //       ctx.quadraticCurveTo(padding + contentWidth, imgY + destImgHeight, padding + contentWidth - radius, imgY + destImgHeight);
  //       ctx.lineTo(padding + radius, imgY + destImgHeight);
  //       ctx.quadraticCurveTo(padding, imgY + destImgHeight, padding, imgY + destImgHeight - radius);
  //       ctx.lineTo(padding, imgY + radius);
  //       ctx.quadraticCurveTo(padding, imgY, padding + radius, imgY);
  //       ctx.closePath();
  //       ctx.clip();
        
  //       ctx.drawImage(mainImg, padding, imgY, contentWidth, destImgHeight);
  //       ctx.restore();
        
  //       // 8. 触发浏览器原生下载
  //       const link = document.createElement("a");
  //       link.download = `recipe_${currentRecipeId || "export"}.jpg`;
  //       link.href = canvas.toDataURL("image/jpeg", 0.95);
  //       link.click();
        
  //       downloadSuccess = true;
  //   } catch (err) {
  //       console.error("长图生成异常:", err);
  //       alert("画像保存に失敗しました");
  //   } finally {
  //       // 无论如何都要恢复按钮，即便上报失败也不应影响用户后续操作
  //       btnDownloadImage.disabled = false;
  //       btnDownloadImage.textContent = "レシピを保存する";
        
  //       // 【关键点】：上报动作放在 finally 后，用异步且独立的方式，不阻塞主 UI
  //       if (currentRecipeId) {
  //           fetch(API_LOG_ACTION, {
  //               method: "POST",
  //               headers: { "Content-Type": "application/json" },
  //               body: JSON.stringify({
  //                   request_id: currentRecipeId,
  //                   action: "download_recipe",
  //                   success: downloadSuccess
  //               })
  //           }).catch(e => console.error("日志上报静默失败:", e));
  //       }
  //   }
  // });

  btnDownloadImage.addEventListener("click", async () => {
    let downloadSuccess = false;

    // 点击后只设置一次按钮状态
    btnDownloadImage.disabled = true;
    btnDownloadImage.textContent = "保存中...";

    try {
      // 同时兼容 textarea 和普通元素
      const textContent = (
        aiOutBox.value ||
        aiOutBox.textContent ||
        aiOutBox.innerText ||
        ""
      ).trim();

      const base64Src = dishImage.src;

      if (!textContent) {
        alert("保存するレシピがありません");
        return;
      }

      if (!base64Src || dishImage.style.display === "none") {
        alert("保存する画像がありません");
        return;
      }

      // 创建画布
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        throw new Error("Canvasを使用できません");
      }

      // 等待图片加载
      const mainImg = new Image();

      await new Promise((resolve, reject) => {
        mainImg.onload = resolve;
        mainImg.onerror = () => {
          reject(new Error("画像の読み込みに失敗しました"));
        };
        mainImg.src = base64Src;
      });

      // 画布尺寸
      const canvasWidth = 750;
      const padding = 40;
      const contentWidth = canvasWidth - padding * 2;

      // 计算文本换行
      ctx.font = "16px sans-serif";

      const lines = [];
      const rawLines = textContent.split("\n");

      rawLines.forEach((rawLine) => {
        if (rawLine.length === 0) {
          lines.push("");
          return;
        }

        let currentLine = "";

        for (let i = 0; i < rawLine.length; i++) {
          const char = rawLine[i];
          const testLine = currentLine + char;
          const metrics = ctx.measureText(testLine);

          if (metrics.width > contentWidth) {
            if (currentLine) {
              lines.push(currentLine);
            }
            currentLine = char;
          } else {
            currentLine = testLine;
          }
        }

        if (currentLine) {
          lines.push(currentLine);
        }
      });

      const lineHeight = 28;
      const textTotalHeight = lines.length * lineHeight;

      // 按原图比例计算图片高度
      const destImgHeight =
        mainImg.naturalHeight *
        contentWidth /
        mainImg.naturalWidth;

      // 设置画布总尺寸
      canvas.width = canvasWidth;
      canvas.height =
        padding +
        textTotalHeight +
        30 +
        destImgHeight +
        padding;

      // 白色背景
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制菜谱文字
      ctx.fillStyle = "#222222";
      ctx.font =
        "16px -apple-system, BlinkMacSystemFont, " +
        "'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
      ctx.textBaseline = "top";

      lines.forEach((line, index) => {
        ctx.fillText(
          line,
          padding,
          padding + index * lineHeight
        );
      });

      // 图片位置
      const imgY = padding + textTotalHeight + 30;
      const radius = 12;

      // 创建圆角裁切区域
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(padding + radius, imgY);
      ctx.lineTo(padding + contentWidth - radius, imgY);

      ctx.quadraticCurveTo(
        padding + contentWidth,
        imgY,
        padding + contentWidth,
        imgY + radius
      );

      ctx.lineTo(
        padding + contentWidth,
        imgY + destImgHeight - radius
      );

      ctx.quadraticCurveTo(
        padding + contentWidth,
        imgY + destImgHeight,
        padding + contentWidth - radius,
        imgY + destImgHeight
      );

      ctx.lineTo(
        padding + radius,
        imgY + destImgHeight
      );

      ctx.quadraticCurveTo(
        padding,
        imgY + destImgHeight,
        padding,
        imgY + destImgHeight - radius
      );

      ctx.lineTo(padding, imgY + radius);

      ctx.quadraticCurveTo(
        padding,
        imgY,
        padding + radius,
        imgY
      );

      ctx.closePath();
      ctx.clip();

      // 绘制菜品图片
      ctx.drawImage(
        mainImg,
        padding,
        imgY,
        contentWidth,
        destImgHeight
      );

      ctx.restore();

      // 下载生成的长图
      const link = document.createElement("a");
      link.download =
        `recipe_${currentRecipeId || "export"}.jpg`;
      link.href = canvas.toDataURL("image/jpeg", 0.95);
      link.click();

      downloadSuccess = true;

    } catch (error) {
      console.error("长图生成异常:", error);
      alert("画像保存に失敗しました");

    } finally {
      // 无论成功失败，都恢复按钮
      btnDownloadImage.disabled = false;
      btnDownloadImage.textContent = "レシピを保存する";

      // 独立上报下载结果，不阻塞页面
      if (currentRecipeId) {
        fetch(API_LOG_ACTION, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            request_id: currentRecipeId,
            action: "download_recipe",
            success: downloadSuccess
          })
        }).catch((error) => {
          console.error("日志上报静默失败:", error);
        });
      }
    }
  });

  function showFeedbackButton() {
    if (feedbackFloatBtn) {
      // 动态将 Liquid 拿到的图片 URL 写入按钮内部
      const iconUrl = window.RECIPE_FEEDBACK_ICON_URL || "";
      feedbackFloatBtn.innerHTML = `<img src="${iconUrl}" alt="評価">`;
      feedbackFloatBtn.style.display = "block";
    }
  }

  function hideFeedbackButton() {
    feedbackFloatBtn.style.display = "none";
  }

  // 定义统一的关闭弹窗函数，顺便恢复滚动
  function closeFeedbackModal() {
      feedbackModal.style.display = "none";
      document.body.style.overflow = ""; // 恢复滚动
  }

  feedbackFloatBtn.addEventListener("click", () => {
      feedbackModal.style.display = "flex";
      document.body.style.overflow = "hidden"; // 禁止底层滚动
  });

  feedbackCancelBtn.addEventListener("click", () => {
      closeFeedbackModal();
  });

  feedbackStars.forEach((star) => {
    star.addEventListener("click", () => {
      feedbackRating = Number(star.dataset.value);

      feedbackStars.forEach((s) => {
        s.classList.toggle("active", Number(s.dataset.value) <= feedbackRating);
      });
    });
  });

  feedbackConfirmBtn.addEventListener("click", async () => {
    const comment = feedbackText.value.trim();
    const ratingValue = feedbackRating;

    if (!currentRecipeId) {
      alert("評価対象のレシピがありません");
      return;
    }
    try {
      const resp = await fetch(API_FEEDBACK, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          recipe_id: currentRecipeId,
          rating: ratingValue,
          comment
        }),
      });
      const data = await resp.json();
      if (data.ok) {
        console.log("反馈已提交");
      }
    } catch (err) {
      console.error("提交反馈失败", err);
    }

    // feedbackModal.style.display = "none";
    closeFeedbackModal();

    hideFeedbackButton();

  });

  init();